import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconStability = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      d="M13.85 5.436c2.175 4.392 2.125 4.189 2.15 4.595 0 1.143-1.425 2.031-3.2 2.031-1.75 0-3.2-.888-3.2-2.03 0-.382-.05-.178 2.125-4.596.425-.89 1.7-.89 2.125 0Zm-2.875 4.189h3.6l-1.8-3.656-1.8 3.656Zm-4.575.406c0 1.143-1.475 2.031-3.2 2.031-1.75 0-3.2-.888-3.2-2.03 0-.382-.05-.178 2.125-4.596.425-.89 1.7-.89 2.125 0C6.425 9.828 6.4 9.625 6.4 10.03ZM3.175 5.97l-1.8 3.656H5L3.175 5.969Zm9.2 6.906c.675 0 1.225.559 1.2 1.219a.398.398 0 0 1-.4.406h-10.4c-.2 0-.4-.178-.4-.406 0-.66.55-1.219 1.225-1.219h3.575V5.41c-.6-.28-1.05-.812-1.175-1.473H3.175c-.425 0-.775-.355-.775-.812 0-.432.35-.813.8-.813h3.2c.35-.482.925-.812 1.575-.812.675 0 1.225.33 1.6.813H12.8c.4 0 .775.38.775.812 0 .457-.35.813-.775.813H9.95A2.086 2.086 0 0 1 8.8 5.41v7.465h3.575Z"
    />
  </svg>
));
export default SvgIconStability;
